module.exports = __webpack_public_path__ + "static/media/close@2x.f6e44c6d.svg";